<template>
  <div>
    <confirmation-dialog
      @confirmed="save"
      :onSetConfirmedDialog="setConfirmedDialog"
      :confirmedDialog="$store.state.medications.confirmedDialog"
      :title="title"
      :content="content"
    />

    <v-snackbar v-model="message.show" top :vertical="true">
      {{ message.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          :color="message.color"
          text
          v-bind="attrs"
          @click="message.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <v-card-title>
        <v-btn class="mr-4" fab dark small color="primary">
          <v-icon dark x-small>
            mdi-share-variant-outline
          </v-icon>
        </v-btn>
        <span class="text-h5">Shared Link</span>
        <span class="text-caption" v-if="status"
          ><v-chip class="ma-2" :color="status.color" text-color="white" small>
            {{ status.status }}
          </v-chip>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <template>
            <v-card class="my-2" flat>
              <v-card class="mx-auto main-container bg-color" dark flat>
                <v-container fluid class="mar-card--container">
                  <div class="d-flex flex-column item-container">
                    <v-card-title class="text-body-1 mr-5">{{
                      specificMarData.Medication
                    }}</v-card-title>

                    <v-card-text class="flex-grow-1">
                      <div class="text-overline white--text">
                        INSTRUCTION
                      </div>
                      <div class=" white--text">
                        {{ specificMarData.MARInstructions }}
                      </div>
                    </v-card-text>
                  </div>
                </v-container>
              </v-card>

              <v-row class="ma-2" dense>
                <v-card-text
                  ><div class="text-subtitle-3">Diagnosis</div>
                  <v-divider class="mt-1"></v-divider>
                </v-card-text>
                <div class="item-container--diagnosis mb-5 ">
                  <v-card-text> {{ specificMarData.Diagnosis }}</v-card-text>
                </div>
              </v-row>

              <v-row class="ma-2" dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Quantity"
                    hide-details
                    outlined
                    disabled
                    dense
                    :value="specificMarData.Quantity"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Admin Time"
                    hide-details
                    outlined
                    :value="specificMarData.AdminTime"
                    dense
                  ></v-text-field>
                </v-col>

                <!-- IF VITALS ARE REQUIRED -->
                <template
                  v-for="(vital, index) in specificMarData.VitalsRequired"
                >
                  <v-col cols="12" md="12" :key="index">
                    <v-text-field
                      :label="vital"
                      v-model="specificMarData.newVitalsRequired[index]"
                      :error-messages="
                        specificMarData.errorVitalsRequired[index]
                      "
                      outlined
                    ></v-text-field>
                  </v-col>
                </template>

                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="notes"
                    label="Notes"
                    outlined
                    hide-details
                    rows="2"
                    row-height="20"
                  ></v-textarea>
                </v-col>

                <v-row dense class="ma-0">
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="amountAdministered"
                      label="Amount Administered to Client"
                      hide-details
                      outlined
                      disabled
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="exception"
                      label="Exception"
                      :items="exceptions"
                      outlined
                      clearable
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="12" class="mt-n8">
                    <v-checkbox
                      label="Signature"
                      @change="addSignature"
                      v-model="signed"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="12" class="mt-n3">
                    <v-text-field
                      v-model="signature"
                      :error-messages="error"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-row>

              <v-card-actions v-if="status.status === 'Incomplete'">
                <!-- <v-btn class="bg-color" dark >
                Status
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn> -->
                <v-btn
                  class="bg-color"
                  dark
                  block
                  @click="onAddItem"
                  :loading="$store.state.medications.isLoading"
                  :disabled="isDisable"
                >
                  submit
                  <template v-slot:loader>
                    <span>Loading...</span>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/*eslint-disable no-unused-vars*/
import { mapActions, mapState, mapMutations } from "vuex";
import ConfirmationDialog from "@/components/shared/ConfirmationDialog";

export default {
  components: {
    ConfirmationDialog,
  },
  props: {
    shareUrlInfo: {
      type: Object,
    },
    clientID: {
      type: String,
    },
  },
  data() {
    return {
      exceptions: [
        "Absent",
        "Dropped",
        "Medication Unavailable",
        "Spit Out",
        "Meds on Hold",
        "Refused",
        "Low Vitals",
        "Other",
      ],
      specificMarData: [],
      notes: "",
      amountAdministered: "",
      status: "",
      exception: "",
      signed: false,
      confirmationDialog: false,
      signature: "",
      error: null,
      staff: localStorage.getItem("Name"),
      vitals: {},
      vitalsRequired: [],
      errorVitalsRequired: [],
      countError: 0,
      title: "Confirming...",
      content: "Do you confirm administering the medication?",
      userID: localStorage.getItem("userID"),
      message: {
        show: false,
        color: "",
        text: "",
      },
    };
  },

  computed: {
    ...mapState({
      confirmed: (state) => state.medications.confirmed,
    }),

    isDisable: {
      get() {
        return this.$store.state.medications.isDisableButton;
      },
      set(val) {
        this.$store.commit("medications/SET_DISABLE_BUTTON", val);
      },
    },
  },

  methods: {
    ...mapActions({
      getLinkInfo: "shareLink/getLinkInfo",
      getSpecificMedication: "medications/getSpecificMedication",
      fetchAllClientMedications: "medications/fetchAllClientMedications",
      addMAR: "mar/addMAR",
      updateMedicationInventory:
        "medicationInventory/updateMedicationInventory",
    }),

    ...mapMutations({
      setConfirmedDialog: "medications/SET_CONFIRMED_DIALOG",
    }),

    async getSharedLink() {
      this.isDisable = false;
      const specificMarResponse = await this.getSpecificMedication({
        id: this.shareUrlInfo.id,
        clientId: this.shareUrlInfo.clientId,
        time: this.shareUrlInfo.time,
      });

      const medications = await this.fetchAllClientMedications(
        this.shareUrlInfo.clientId
      );

      this.getMarInfo(
        medications,
        this.shareUrlInfo.id,
        this.shareUrlInfo.clientId,
        this.shareUrlInfo.time
      );

      this.specificMarData = specificMarResponse.data.data[0];

      let vitalSigns = [];
      this.specificMarData.VitalsRequired.forEach(() => {
        vitalSigns.push("");
      });

      this.specificMarData.newVitalsRequired = vitalSigns;
      this.specificMarData.errorVitalsRequired = [];

      this.amountAdministered = this.specificMarData.AdministerAmount;
    },

    onAddItem() {
      //Todo submitting shared URL
      //data from specific medication
      // const {_id, Medication, AdministerAmount, AdminTime, ClientID, Quantity, PRN } = this.specificMarData
      // notes, exception, date, staffId, PRN, UrlNotification, NewVitalsRequired, VitalsRequired

      let countError = 0;

      let { newVitalsRequired, errorVitalsRequired } = this.specificMarData;

      if (this.signature === "") {
        this.error = "Signature is required";
        countError++;
      }

      newVitalsRequired?.forEach((value, index) => {
        if (value === "") {
          countError++;
          errorVitalsRequired[index] = "Vital is required";
        } else {
          return (errorVitalsRequired[index] = "");
        }
      });

      if (countError == 0) {
        this.setConfirmedDialog(true);
      } else {
        return errorVitalsRequired, this.error, (this.isDisable = false);
      }
    },

    async save() {
      //Todo submitting shared URL
      this.setConfirmedDialog(false);
      this.isDisable = true;
      const {
        _id,
        Medication,
        AdministerAmount,
        AdminTime,
        ClientID,
        Quantity,
        newVitalsRequired,
        VitalsRequired,
        MedInventory,
        PRN,
      } = this.specificMarData;

      let req_body = {
        Medication: _id,
        MedicationName: Medication,
        AmountAdministered: AdministerAmount,
        AdminTime: AdminTime,
        Notes: this.notes,
        Exception: this.exception,
        Signature: this.signature,
        ClientID: ClientID,
        Quantity: Quantity,
        VerifiedBy: "",
        Date: new Date(),
        StaffID: this.userID,
        PRN: PRN,
        UrlNotification: this.$router.history.current.path,
        NewVitalsRequired: newVitalsRequired,
        VitalsRequired: VitalsRequired,
        ActualAdminTime: new Date(),
      };

      try {
        let res = await this.updateMedicationInventory({
          id: MedInventory,
          Quantity: Quantity,
        });

        if (res.data.success) {
          let response = await this.addMAR(req_body);
            console.log(response)
          if (response.status == 400) {
            return this.messageDialog(true, "error", "An Error Occured");
          }
          this.messageDialog(
            true,
            "pink",
            "The new MAR item has been added successfully."
          );
        } else {
          if (!res.data.success) {
            this.isDisable = false;
            return this.messageDialog(true, "error", res.data.msg);
          }
          if (res.status === 404) {
            this.isDisable = false;
            return this.messageDialog(true, "error", "An Error Occured");
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    addSignature() {
      if (this.signed) {
        this.signature = this.staff + " - " + new Date();
        this.error = "";
      } else {
        this.signature = "";
        this.error = "";
      }
    },

    getMarInfo(medications, id, clientId, time) {
      const medicationStatus = medications.find(
        (item) =>
          item._id === id &&
          item.ClientID === clientId &&
          item.AdminTime === time
      );

      if (medicationStatus.Signed === true) {
        this.status = {
          status: "Complete",
          color: "success",
        };
      } else {
        this.status = {
          status: "Incomplete",
          color: "red",
        };
      }
    },

    messageDialog(show, color, text) {
      this.message.show = show;
      this.message.color = color;
      this.message.text = text;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  transform: none !important;
}

.main-container {
  border-radius: 0 !important;
}

.mar-card--container {
  position: relative;
}

.mar-checkbox {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 5px;
}

.bg-color {
  background: linear-gradient(
    169deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(2, 97, 217, 1) 0%,
    rgba(30, 177, 148, 1) 100%
  );
}

.v-card--reveal {
  bottom: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  width: 10 0%;
  background-color: #fff;
  border-radius: 0 !important;
}

.panel-header {
  min-height: 100px;
}

.item-container {
  height: 100px;
}

.diagnosis-container {
  position: relative;
}

.item-container--diagnosis {
  height: 30px;
}

.fab-multiple {
  z-index: 999;
}
</style>
